export default function () {
  return {
    page: 1,
    totalPages: 0,
    perPage: 15,
    searchParams: {},
    items: [],
    fields: [
      {
        key: 'name',
        label: 'Nome'
      },
      {
        key: 'actions',
        label: 'Ações'
      }
    ]
  }
}
